'use client';

import { useEffect } from 'react';

function applyFavicon(url: string) {
  if (!url) return;

  const links = document.querySelectorAll('link[rel~="icon"], link[rel="shortcut icon"]');

  if (!links.length) {
    const icon = document.createElement('link');
    icon.rel = 'icon';
    icon.href = url;
    document.head.appendChild(icon);

    const shortcut = document.createElement('link');
    shortcut.rel = 'shortcut icon';
    shortcut.href = url;
    document.head.appendChild(shortcut);
    return;
  }

  links.forEach((link) => {
    link.setAttribute('href', url);
  });
}

export default function GlobalFaviconSync() {
  useEffect(() => {
    let canceled = false;

    fetch('/api/public-branding', { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) return null;
        return response.json();
      })
      .then((data) => {
        if (canceled || !data?.favicon_data_url) return;
        applyFavicon(String(data.favicon_data_url));
      })
      .catch(() => {});

    return () => {
      canceled = true;
    };
  }, []);

  return null;
}
